import Vue from "vue";

export default {
    recuperarFiltro(paramsFiltro, pagina, numElementosPagina, ordenacao) {
        return Vue.axios.post("historicoNomeSocial/filtro", {
            params: {
                nome: paramsFiltro.nome,
                cpf: paramsFiltro.cpf,
            },
            pagina,
            numElementosPagina,
            ordenacao
        });

    },
    atualizaAvaliacao(item){
        return Vue.axios.post('historicoNomeSocial/atualizaAvaliacao/'+item.cpf, {
            avaliacao: item.avaliacao
        });
    }
}